import { getRelativePath } from 'helpers/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { Badge, Card, Nav } from 'react-bootstrap';
import { NavLink, useNavigate, useLocation, useParams } from 'react-router-dom';
import paths from 'routes/paths';
import { Can } from 'routes/permissions/Can';
import {
  permissionsKeyMap,
  userActions
} from 'routes/permissions/permissionKeys';
import IconButton from '../IconButton';
import classNames from 'classnames';

const NavBar = ({ navLinks, type }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const isNavLinkActive = link =>
    getRelativePath(location.pathname, paths.donorDetails) ===
    getRelativePath(link, paths.donorDetails);

  return (
    <Card className="mb-3">
      <Card.Body className="p-3">
        <Nav className="flex-row" style={{ justifyContent: 'space-between' }}>
          {/* flex at every breakpoint so tabs flow into rows on phones
              instead of stacking one per line */}
          <div className="d-flex flex-wrap">
            {navLinks.map(({ id, link, isNotRelative, title, count }) => (
              <Nav.Item key={id} className="nav-pills">
                <Nav.Link
                  className="fw-medium d-flex align-items-center"
                  style={{ fontSize: '1rem' }}
                  as={NavLink}
                  to={
                    isNotRelative
                      ? link
                      : getRelativePath(link, paths.donorDetails)
                  }
                >
                  {title}
                  {count > 0 && (
                    <Badge
                      pill
                      className={classNames('ms-1', {
                        'bg-white text-primary': isNavLinkActive(link)
                      })}
                    >
                      {count}
                    </Badge>
                  )}
                </Nav.Link>
              </Nav.Item>
            ))}
          </div>
          {type !== 'Beneficiary' && (
            <Can
              I={userActions.create}
              a={permissionsKeyMap.donation.children.donations}
            >
              <IconButton
                icon="plus"
                variant="primary"
                className="d-block"
                style={{
                  height: 'fit-content',
                  right: 0,
                  marginRight: '21px'
                }}
                onClick={() =>
                  navigate(paths.addDonationConfig + `?donorId=${id}`)
                }
              >
                <span className="d-block d-md-inline-block ms-2">
                  Add Donation
                </span>
              </IconButton>
            </Can>
          )}
        </Nav>
      </Card.Body>
    </Card>
  );
};

NavBar.propTypes = {
  navLinks: PropTypes.array,
  user: PropTypes.object,
  score: PropTypes.bool,
  type: PropTypes.string,
  donorId: PropTypes.string
};
export default NavBar;
